'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';
import { validAccess } from 'accessControl';

const __endpoints = require('endpoints.service');

export default class GlobalAccountsList extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'name',
				type: 'string',
			},
			{
				name: 'type',
				type: 'string',
			},
		];
		this.settings = {
			name: 'GlobalAccountsList',
			pageTitle: true,
			hasDetails: true,
			canCreate: true,
			translationPath: 'ACCOUNTING.GLOBAL_ACCOUNTS',
			canManipulate: () => validAccess(undefined, ['Global HR Configuration']),
			endpoint: __endpoints.collection.accounting.global_accounts,
		};
		this.init();
		return this;
	}
}
